module.exports = __webpack_public_path__ + "static/media/big-little-dippers-chocolate-chunk@2x.027d1e0c.png";